// src/routes/ProtectedRoute.jsx
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute() {
  const { user, isSessionReady } = useAuth();
  const location = useLocation();

  if (!isSessionReady) {
    return (
      <Box
        sx={{
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <CircularProgress size={96} thickness={4} sx={{ color: "#0b3b5e" }} />
      </Box>
    );
  }

  // If no logged-in user, redirect to login
  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  // User is authenticated - render the nested routes
  return <Outlet />;
}
